import { useEffect, useState } from "react"
import { useNavigate } from "react-router-dom"
import { useAppDispatch, useAppSelector } from "../../../lib/redux/hooks"
import { Layout } from "../../../ui/layout"
import { ButtonComponent } from "../../../ui/molecules/button/newButton"
import { MadfarmInput } from "../../../ui/molecules/input/newInput"
import { MadfarmStaticSelect } from "../../../ui/molecules/select/newSelect/static"
import { CustomHorizontalTab } from "../../../ui/organisms/customHorizontalTab"
import { MenuItems } from "../../../ui/organisms/navbar/dto"
import { yearOptions } from "../../../utils"
import { SOTFilter } from "../../sot"
import { ReinforcedCustomerList } from "./customerList"
import { ReinforcedList } from "./list"
import { GetAllReinforcedControlMeasures, resetGetAllReinforcedControlMeasureFilters, resetReinforcedControlMeasureCreationStatus, resetReinforcedControlMeasureUpdateStatus, setGetAllReinforcedCountryRegion, setGetAllReinforcedHeadQuarter, setGetAllReinforcedYear } from "./slice"

export function ReinforcedControlMeasure() {
    const navigate = useNavigate()
    const dispatch = useAppDispatch()
    const sessionState = useAppSelector(state => state.session)
    const reinforcedControlMeasureState = useAppSelector(state => state.reinforcedControlMeasure)
    const [selectedTab, setSelectedTab] = useState<number>(0)
    const [showSuccess, setShowSuccess] = useState<boolean>(false)

    useEffect(() => {
        if (reinforcedControlMeasureState.reinforcedControlMeasureCreationStatus === 'successfully') {
            dispatch(resetReinforcedControlMeasureCreationStatus())
            setShowSuccess(true)
        }
        if (reinforcedControlMeasureState.reinforcedControlMeasureUpdateStatus === 'successfully') {
            dispatch(resetReinforcedControlMeasureUpdateStatus())
            setShowSuccess(true)
        }
    }, [reinforcedControlMeasureState.reinforcedControlMeasureCreationStatus,
    reinforcedControlMeasureState.reinforcedControlMeasureUpdateStatus
    ])

    useEffect(() => {
        if (showSuccess) {
            setTimeout(() => {
                setShowSuccess(false)
            }, 2000)
        }
    }, [showSuccess])

    return (
        <Layout
            menuItem={MenuItems.GESTIONE_PROVVEDIMENTI}
            breadcrumbItems={['Gestione Provvedimenti', 'Misura di Controllo Rinforzato']}
            noPaddingLat
            headerLabel="Misura di Controllo Rinforzato"
            headerChildren={
                <div className="flex items-center h-[100%] w-[100%] justify-end">
                    <ButtonComponent
                        size={"sm"}
                        iconPosition={"off"}
                        variant={"solid"}
                        label="Crea nuovo"
                        color={"orange"}
                        disabled={!sessionState.selected.customerId}
                        onClick={() => {
                            navigate('/addReinforcedControlMeasure')
                        }}
                    />
                </div>
            }
        >
            <CustomHorizontalTab
                selectedIndex={selectedTab}
                onTabClick={(index) => setSelectedTab(index)}
            >
                <div>Elenco cliente</div>
                <div>Elenco completo</div>
            </CustomHorizontalTab>
            {
                selectedTab !== 0 && (
                    <div className="flex flex-row gap-2 items-center px-4 pt-4">
                        <MadfarmStaticSelect
                            placeholder={'Anno'}
                            value={reinforcedControlMeasureState.getAllReinforcedControlMeasureFilters.year}
                            options={yearOptions}
                            onChange={(value) => {
                                //@ts-ignore
                                const newValue = value !== null ? value.value : null
                                dispatch(setGetAllReinforcedYear(newValue))
                            }}
                            noOptionsMessage={""}
                        />
                        <SOTFilter
                            value={reinforcedControlMeasureState.getAllReinforcedControlMeasureFilters.headQuarter}
                            // disabled={usersState.findMeResponse.headQuarterInfo?.code !== 'SC' && usersState.findMeResponse.role !== 'admin'}
                            onChange={(value) => dispatch(setGetAllReinforcedHeadQuarter(value))}
                        />
                        <MadfarmInput
                            placeholder={'Regione'}
                            value={reinforcedControlMeasureState.getAllReinforcedControlMeasureFilters.countryRegion}
                            onChangeText={(value) => dispatch(setGetAllReinforcedCountryRegion(value))}
                        />
                        <div className="flex gap-2 items-center">
                            <ButtonComponent
                                size={"lg"}
                                iconPosition={"off"}
                                variant={"outline"}
                                label="Pulisci"
                                color={"gray"}
                                onClick={() => dispatch(resetGetAllReinforcedControlMeasureFilters())}
                            />
                            <ButtonComponent
                                variant='outline'
                                color='orange'
                                size='lg'
                                iconPosition='off'
                                label='Cerca'
                                onClick={() => dispatch(GetAllReinforcedControlMeasures(reinforcedControlMeasureState.getAllReinforcedControlMeasureFilters))}
                            />
                        </div>
                    </div>
                )
            }
            {
                showSuccess &&
                <div className="gap-[8px] text-left m-6 rounded-xl bg-[#D1F5D9] border-2 border-[#8AE59F]">
                    <span className="text-green-700 fieldsetTitle block px-[25px] py-[30px] text-sm font-bold font-['Roboto']">
                        Dati salvati correttamente.
                    </span>
                </div>
            }

            <div className="fieldset bg-brandPrimary-200">
                {
                    selectedTab === 0 &&
                    <ReinforcedCustomerList />
                }
                {
                    selectedTab === 1 &&
                    <ReinforcedList />
                }
            </div>
        </Layout>
    )
}